__turbopack_context__.v({
  "button": "gray-module-scss-module__PwJN1a__button" + " " + __turbopack_context__.i(693367)["block"],
  "complete": "gray-module-scss-module__PwJN1a__complete" + " " + __turbopack_context__.i(693367)["complete"],
  "medium": "gray-module-scss-module__PwJN1a__medium" + " " + __turbopack_context__.i(693367)["medium"],
  "playing": "gray-module-scss-module__PwJN1a__playing" + " " + __turbopack_context__.i(693367)["playing"],
  "small": "gray-module-scss-module__PwJN1a__small" + " " + __turbopack_context__.i(693367)["small"],
});
